<template>
  <div>
    <SliderComponent :slide-items="sliderImages"/>
    <HomeSectionOne/>
    <HomeSectionTwo/>
    <HomeSectionThree :offers="offers"/>
  </div>
</template>

<script>
import SliderComponent from '../components/SliderComponent'
import HomeSectionOne from '../components/home/HomeSectionOne'
import HomeSectionTwo from '../components/home/HomeSectionTwo'
import HomeSectionThree from '../components/home/HomeSectionThree'
import store from '../store'

export default {
  name: 'Home',
  components: { HomeSectionThree, HomeSectionTwo, HomeSectionOne, SliderComponent },
  data: function () {
    return {
      offers: store.state.home.offers
    }
  },
  mounted () {
    this.fetchSlider()
  },
  methods: {
    fetchSlider () {
      this.$store.dispatch('home/fetchSliderImages')
    }
  },
  computed: {
    sliderImages: function () {
      return store.getters['home/sliderImages']
    }
  }
}
</script>

<style scoped>
</style>
